import { PreferredLanguage, PreferredLanguageDisplayNames } from "@remi/enums/preferred-language";
import { RemiSeparator } from "@remi/next-ui";

import { usePersonNotes } from "~/hooks/person/usePersonNotes";
import { usePerson } from "~/hooks/usePerson";
import { cn } from "~/lib/utils";
import { PinnedNotePreview } from "./PinnedNotePreview";

interface PersonNoteSectionProps {
  personId: string;
}
export const PersonPills = ({ personId }: { personId: string }) => {
  const { data: person } = usePerson(personId);
  if (!person) {
    return null;
  }
  const preferredLanguage = person.contact.preferredLanguage;
  if (preferredLanguage === PreferredLanguage.ENGLISH) {
    return null;
  }
  return (
    <div className="flex w-full flex-wrap gap-1 px-1">
      <div className="flex h-5 items-center rounded-full bg-background-accentMedium px-2 font-medium text-text-primary text-xs">
        {PreferredLanguageDisplayNames[preferredLanguage]} speaker
      </div>
    </div>
  );
};
export const PersonNoteSection = ({ personId }: PersonNoteSectionProps) => {
  const { data: person } = usePerson(personId);
  const { data = [] } = usePersonNotes(personId);

  const notes = data.filter((note) => note.isPinned);

  if (!person || (person.contact.preferredLanguage === PreferredLanguage.ENGLISH && notes.length === 0)) {
    return null;
  }
  const preferredLanguage = person.contact.preferredLanguage;

  return (
    <>
      <RemiSeparator orientation="horizontal" className="w-full" />
      <div className="flex w-full flex-col">
        {preferredLanguage !== PreferredLanguage.ENGLISH && (
          <div className={cn("flex w-full flex-row gap-1 p-4", notes.length === 0 ? "pb-0" : "pb-3")}>
            <PersonPills personId={personId} />
          </div>
        )}

        {notes.length > 0 && (
          <div className={cn("w-full px-4 pb-4", preferredLanguage === PreferredLanguage.ENGLISH && "pt-4")}>
            <PinnedNotePreview personId={personId} />
          </div>
        )}
      </div>
    </>
  );
};
